import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then(({ data: d }) => setData(d)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  const onOpen = (open) => {
    if (open && data.unread) api.post("/notifications/read-all").then(() => setData((d) => ({ ...d, unread: 0 }))).catch(() => {});
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-full hover:bg-slate-100 transition-colors" aria-label="Notifications" data-testid="notif-bell">
          <Bell className="w-5 h-5 text-[#1A2E28]" />
          {data.unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center" data-testid="notif-count">{data.unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notif-panel">
        <div className="px-4 py-3 border-b border-[#E2E8F0] font-semibold text-sm">Notifications</div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.map((n) => (
            <button key={n.id} onClick={() => n.link && navigate(n.link)} className={`w-full text-left px-4 py-3 border-b border-[#E2E8F0] last:border-0 hover:bg-[#F6F8F9] ${n.read ? "" : "bg-[#E8F2EF]/50"}`} data-testid="notif-item">
              <div className="text-sm font-semibold">{n.title}</div>
              <div className="text-xs text-[#5C736A] mt-0.5">{n.message}</div>
              <div className="text-[10px] text-[#5C736A] mt-1">{new Date(n.created_at).toLocaleString("fr-FR")}</div>
            </button>
          ))}
          {!data.items.length && <div className="px-4 py-8 text-center text-sm text-[#5C736A]">Aucune notification.</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
